import { buildFormPath, buildStudyAccessPath } from "./onboardingPaths";

function clean(value) {
  if (value === undefined || value === null) {
    return null;
  }

  const nextValue = String(value).trim();
  return nextValue.length ? nextValue : null;
}

function normalizeLatestMetadataMs(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export function hasCompletedStudyAccess({ subjectId, clinicStudyId }) {
  return Boolean(clean(subjectId) && clean(clinicStudyId));
}

export function hasCompletedMetadata({
  latestMetadataMs,
  isReturning = false,
}) {
  return Boolean(normalizeLatestMetadataMs(latestMetadataMs) || isReturning);
}

export function resolveOnboardingStage({
  subjectId,
  clinicStudyId,
  latestMetadataMs,
  isReturning = false,
}) {
  if (!hasCompletedStudyAccess({ subjectId, clinicStudyId })) {
    return "study-access";
  }

  if (!hasCompletedMetadata({ latestMetadataMs, isReturning })) {
    return "metadata";
  }

  return "complete";
}

export function resolveOnboardingRedirectPath({
  stage,
  search = "",
  next = null,
}) {
  if (stage === "study-access") {
    return buildStudyAccessPath({ search, next });
  }

  if (stage === "metadata") {
    return buildFormPath({ search, next });
  }

  return "/home";
}
